module.exports = __webpack_public_path__ + "static/media/pdfIcon.b01e671b.png";